export const environment = {
    production: false,
    apiUrl: 'https://apiv2dev.myvesper.fr',
    mercureHubUrl: 'https://apiv2dev.myvesper.fr/.well-known/mercure',
    crispWebsiteId: '1075a9c7-a22b-46e6-95a2-1bf9aa73d2ed', // Remplacez par votre Website ID Crisp
    intercomAppId: '',
    sentryDsn: "https://9bcb5b4b1b80cd829d1c31c686e2a4c6@o4510085679808512.ingest.us.sentry.io/4510085727846400",
    sentryEnabled: false,
    sentryEnvironment: 'development'
};
